import React from 'react';

import { Box } from '@lightspeed/flame/Core';
import { IconEyeOn } from '@lightspeed/flame/Icon/EyeOn';
import { Modal, ModalBody, ModalHeader } from '@lightspeed/flame/Modal';
import { Text, TextLink } from '@lightspeed/flame/Text';

import {
  DueAmountFormats,
  usePaymentTermsInputContext,
} from '../contexts/CreditStatementTermsContext';
import { StyledIframe } from './Common.style';
import { CREDIT_ACCOUNT_STATEMENT_FORM_URL } from './PaymentTermsContainer';
import { PaymentTermsInputProps } from './PaymentTermsInput';

const PreviewModal = ({
  openModalAfterLangSelection,
}: Pick<PaymentTermsInputProps, 'openModalAfterLangSelection'>) => {
  const {
    globalState: { printDocumentLanguage, startDate, endDate, openModal },
    constantProps: {
      creditAccount: { id: creditAccountId },
      printDocumentLanguageCount,
    },
    setGlobalState,
    getDueAmount,
    getDueDate,
  } = usePaymentTermsInputContext();

  const balanceCheckUrl = `${CREDIT_ACCOUNT_STATEMENT_FORM_URL}&credit_account_id=${creditAccountId}&start=${startDate}&end=${endDate}&language=${printDocumentLanguage}&due_amount=${getDueAmount(
    DueAmountFormats.DECIMAL
  )}&due_date=${getDueDate()}&no-print-preview`;

  const handlePreviewClick = () => {
    // If print document language is not set, show language modal and after selection, show preview modal
    if (printDocumentLanguage === '') {
      setGlobalState((prevState) => ({ ...prevState, openModal: 'printDocumentLanguage' }));
      openModalAfterLangSelection('preview');
    } else {
      setGlobalState((prevState) => ({ ...prevState, openModal: 'preview' }));
    }
  };

  const handleModalClose = () => {
    if (parseInt(printDocumentLanguageCount, 10) > 1) {
      setGlobalState((prevState) => ({
        ...prevState,
        openModal: 'none',
        printDocumentLanguage: '',
      }));
    } else {
      setGlobalState((prevState) => ({
        ...prevState,
        openModal: 'none',
      }));
    }
  };

  return (
    <Box style={{ position: 'absolute', right: '0px', top: '-58px' }}>
      <Text>
        <TextLink
          onClick={() => handlePreviewClick()}
          style={{ borderBottom: 'none' }}
          data-test="preview-link"
          color="#020203"
        >
          Preview
          <span>
            <IconEyeOn />
          </span>
        </TextLink>
      </Text>
      <Modal
        isOpen={openModal === 'preview'}
        onRequestClose={() => handleModalClose()}
        css={{ width: '805px', height: '635px' }}
        closeOnEsc={true}
      >
        <ModalHeader>Account statement preview</ModalHeader>
        <ModalBody>
          <StyledIframe
            src={balanceCheckUrl}
            title="Account statement preview"
            id="printPreviewIframe"
            data-test="printPreviewIframe"
          />
        </ModalBody>
      </Modal>
    </Box>
  );
};

export default PreviewModal;
